// src/elements/Icon/generated/icons.types.ts
var NAME_MAP = {
  "24h": "24h",
  "address-book": "address-book",
  "arrow-autofit-height": "arrow-autofit-height",
  "arrow-autofit-width": "arrow-autofit-width",
  "arrow-back-up": "arrow-back-up",
  "arrow-down": "arrow-down",
  "arrow-forward-up": "arrow-forward-up",
  "arrow-left": "arrow-left",
  "arrow-right": "arrow-right",
  "arrow-up": "arrow-up",
  "badge-3d": "badge-3d",
  "bags-category": "bags-category",
  "bars": "bars",
  "calendar": "calendar",
  "caret-down": "caret-down",
  "caret-left": "caret-left",
  "caret-right": "caret-right",
  "caret-up": "caret-up",
  "catering-industry-category": "catering-industry-category",
  "chat-zendesk": "chat-zendesk",
  "chat": "chat",
  "check-orange": "check-orange",
  "check": "check",
  "checklist": "checklist",
  "chevron-down": "chevron-down",
  "chevron-left": "chevron-left",
  "chevron-right": "chevron-right",
  "chevron-up": "chevron-up",
  "christmas-tree-solid": "christmas-tree-solid",
  "christmas-tree": "christmas-tree",
  "circle-check": "circle-check",
  "clock": "clock",
  "clothing-and-textiles-category": "clothing-and-textiles-category",
  "complaints": "complaints",
  "copy": "copy",
  "copyright-regular": "copyright-regular",
  "corporate-identity-category": "corporate-identity-category",
  "crown": "crown",
  "cup": "cup",
  "customer-service": "customer-service",
  "delivery-method": "delivery-method",
  "delivery-truck": "delivery-truck",
  "design-method": "design-method",
  "designer": "designer",
  "discount-check": "discount-check",
  "discount": "discount",
  "dot": "dot",
  "double-chevron-down": "double-chevron-down",
  "double-chevron-left": "double-chevron-left",
  "double-chevron-right": "double-chevron-right",
  "double-chevron-up": "double-chevron-up",
  "download": "download",
  "edit": "edit",
  "enlarge": "enlarge",
  "envelope": "envelope",
  "euro-sign": "euro-sign",
  "exclamation-circle": "exclamation-circle",
  "exclamation": "exclamation",
  "eye-check": "eye-check",
  "eye-closed": "eye-closed",
  "eye": "eye",
  "facebook-square": "facebook-square",
  "file-pdf": "file-pdf",
  "file": "file",
  "hearts": "hearts",
  "home": "home",
  "image": "image",
  "info": "info",
  "input-checkbox-select": "input-checkbox-select",
  "input-checkbox": "input-checkbox",
  "input-radio-backdrop": "input-radio-backdrop",
  "input-radio-select": "input-radio-select",
  "input-radio": "input-radio",
  "inspiration-and-advice-category": "inspiration-and-advice-category",
  "instagram-square": "instagram-square",
  "jacket": "jacket",
  "leaf": "leaf",
  "light-bulb": "light-bulb",
  "link": "link",
  "linkedin-square": "linkedin-square",
  "list": "list",
  "lock-off": "lock-off",
  "lock": "lock",
  "minus": "minus",
  "mood-kid": "mood-kid",
  "more": "more",
  "order-overview": "order-overview",
  "orders": "orders",
  "outdoor-advertising-category": "outdoor-advertising-category",
  "packaging-category": "packaging-category",
  "partner-discount": "partner-discount",
  "partner": "partner",
  "payment": "payment",
  "phone": "phone",
  "photo-edit": "photo-edit",
  "photo-products-category": "photo-products-category",
  "pinterest-square": "pinterest-square",
  "player-play-filled": "player-play-filled",
  "player-play": "player-play",
  "plus": "plus",
  "presentation-category": "presentation-category",
  "promotion-category": "promotion-category",
  "promotional-gifts-category": "promotional-gifts-category",
  "promotional-gifts-solid": "promotional-gifts-solid",
  "question-mark": "question-mark",
  "refresh": "refresh",
  "repeat": "repeat",
  "resize": "resize",
  "ring-divided": "ring-divided",
  "ring": "ring",
  "rotate-clockwise": "rotate-clockwise",
  "rotate": "rotate",
  "save": "save",
  "search": "search",
  "shopping-cart": "shopping-cart",
  "sparkles": "sparkles",
  "spinner": "spinner",
  "star-half": "star-half",
  "star": "star",
  "stickers-category": "stickers-category",
  "store": "store",
  "times": "times",
  "trashcan": "trashcan",
  "truck": "truck",
  "twitter-square": "twitter-square",
  "umbrella": "umbrella",
  "upload": "upload",
  "user": "user",
  "youtube-square": "youtube-square",
  "zoom-minus": "zoom-minus",
  "zoom-plus": "zoom-plus"
};
export { NAME_MAP };